import React, { useState } from 'react';
import '../styles/calculator.css';

const consolationPoints = {
  1: 7.5,
  2: 4.5,
  3: 3,
  4: 1.5,
  5: .75,
  'Y': .75,
  };
  
  const nominationPoints = {
    1: 1,
    2: .75,
    3: .5,
    4: .25,
    5: .25,
    'Y': .25,
  };

export const PointsDisplayTable = ({calcParams, displayTable}) => {
  const {
    division,
    goRounds,
    finalsPlaces,
    aggregatePlaces,
  } = calcParams;

  const totalMaxPoints = displayTable[1].reduce((a, b) => a + b || 0, -1);
  const headers = [...displayTable[0]];
  const rows = displayTable.reduce((table, row, index) => {
    index > 0 && table.push(row);
    return table;
  },[]);
  
  return (<>
    <div id="tableDiv" className="calculator-form calculator-table">
      <h2>Report {headers.length > 1 && `Division ${division}`}</h2>
      <p className="black-font">
        Go Rounds: {goRounds}, Finals: {finalsPlaces ? 'Y' : 'N'}, Aggregate: {aggregatePlaces ? 'Y' : 'N'}
      </p>
      <h4>Estimated Competition Points*</h4>
      <p>*For example purpose only. NOT Official</p>
      <div className="responsive-table">
        <table border="1">
          <tbody>
            <tr>{headers.map((header, i) => <th key={i}>{header}</th>)}</tr>
            {rows.map((row, index) => (
              <tr key={index}>
                {/* {row.map((cell, cellIndex) => <td key={cellIndex}>{cell != '' ? cell.toFixed(1) : cell}</td> )} */}
                {row.map((cell, cellIndex) => <td key={cellIndex}>{cell > 0 ? cell.toFixed(1) : cell}</td> )}
              </tr>
            ))}
            <tr>
              <td colSpan={headers.length - 1} className="right-align">
                <strong>Total Max Points</strong>
              </td>
              <td><strong>{totalMaxPoints}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div id="tableDiv" className="calculator-form calculator-table">
      <div className="responsive-table">
        <table border="1">
          <tbody>
            <tr>
              <td colSpan={headers.length - 1}>Consolation Points</td>
              <td className="right-align">{consolationPoints[division]}</td>
            </tr>
            <tr>
              <td colSpan={headers.length - 1}>Nomination points</td>
              <td className="right-align">{nominationPoints[division]}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </>);
};